if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form && this.form.querySelector('[name=id]')) {
        this.form.querySelector('[name=id]').disabled = false;
      }
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]:not(.proxy-submit-button)') || this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      this.cart = this.cart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.submitButton || this.querySelector('[type="submit"]:not(.proxy-submit-button)') || this.querySelector('[type="submit"]');

      if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      if (this.submitButton) {
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
      }
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id || section.section));
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
      }
      config.body = formData;

      const cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

      fetch(`${cartAddUrl}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status && response.status !== 200) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            }
            this.handleErrorMessage(response.description || response.message);

            if (this.submitButton) {
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', 'true');
                const span = this.submitButton.querySelector('span');
                if (span) span.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
            }
            this.error = true;
            return;
          }

          if (!this.error && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          }
          this.error = false;

          // Re-fetch cart instance if it was dynamically mounted
          this.cart = this.cart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');

          if (!this.cart) {
            window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
            return;
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { 
                if (this.cart && typeof this.cart.renderContents === 'function') {
                  this.cart.renderContents(response);
                }
              }, 50);
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(response);
            }
          }
        })
        .catch((e) => {
          console.error('Error adding to cart:', e);
        })
        .finally(() => {
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
